// İSG uzmanı portalı — pano paneli başlığı (S32b `docs/reviews/S32b-gate-desk-relayout.md` §3,
// "Panel language (O2)"). `apps/web-supplier`'ın pano kartlarıyla (`UpcomingPermitsCard.tsx:145-
// 162` vb., reported) BİREBİR aynı kanonik şekil: `border-b border-border px-5 py-3` →
// `flex min-h-* items-center justify-between` → `Icon(h-4 w-4 text-primary) + <h2 text-base
// font-semibold>` + sağ yuva.
//
// **Bilinçli sapma [P]: `min-h-9`, tedarikçinin `min-h-8`'i DEĞİL.** `Giriş` panelinin başlığı
// `Tabs` grubunu (`h-9` düğmeler, `Tabs.tsx:105`) taşır; `min-h-8`'de o TEK panelin başlığı
// diğer ikisinden 4px daha uzun dururdu — O2'nin "consistent header height" kuralını tam olarak
// O3'ün getirdiği eleman BOZARDI. Üç panelin ÜÇÜ de bu yüzden `min-h-9`; geri `8`'e
// "düzeltilmemeli".
//
// **Promoted (S34-4, design review `S34-carbon-phase2-plan.md` §4 "Aksiyon gerekli" bölümü) —
// `pages/security/PanelHeader.tsx`'ten `components/`e.** Eski dosya başlığı "yalnız `/security`
// sayfası kullanır, `packages/shared/src/ui/`e TAŞINMAZ" diyordu; Panel'in "Aksiyon gerekli" +
// grafik panelleri de AYNI kanonik şekli istediği için ikinci bir kopya YERİNE bu dosya
// `apps/web-expert/src/components/`e taşındı (paket sınırı DEĞİŞMEDİ — hâlâ yalnız bu app'in
// KENDİ sayfaları arasında paylaşılır, `packages/shared`e taşınmadı).

import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

export function PanelHeader({
  icon: Icon,
  title,
  right,
}: {
  icon: LucideIcon;
  title: string;
  right?: ReactNode;
}) {
  return (
    <div className="border-b border-border px-5 py-3">
      <div className="flex min-h-9 flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-1.5">
          <Icon className="h-4 w-4 shrink-0 text-primary" aria-hidden="true" />
          <h2 className="text-base font-semibold text-fg">{title}</h2>
        </div>
        {right}
      </div>
    </div>
  );
}
